import Header from "./Header";
import QaabXisaab from "./Qaab-xisaabin";
import Qiimayaal from "./Qiimayaal"
import Dhaqdhaqaaq from "./Dhaqdhaqaaq";
import Sinup from "./Singup";
import Login from "./Login";
import Footer from "./Foote";
import SakoModel from "./SakoModel";
import Alert from "./Alert";

function FullHome(){
  let x = 9.656;
console.log(x.toPrecision(2))
console.log(x.toExponential(4))
console.log(x.toExponential(6))
    return(
        <>
      <Header />
      <Qiimayaal />
      <QaabXisaab />
      <Dhaqdhaqaaq/>
      <Sinup />
      <Login />
      <SakoModel />
      <Alert />
      <Footer />
        </>
    )
}


export default FullHome